"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var browser = _interopRequireWildcard(require("../common/browser"));

var _tinymce = _interopRequireDefault(require("tinymce/tinymce"));

require("tinymce/themes/modern/theme");

require("tinymce/plugins/autolink/plugin");

require("tinymce/plugins/autoresize/plugin");

require("tinymce/plugins/link/plugin");

require("tinymce/plugins/noneditable/plugin");

require("tinymce/plugins/media/plugin");

require("tinymce/plugins/textcolor/plugin");

require("tinymce/plugins/directionality/plugin");

require("tinymce/plugins/lists/plugin");

require("tinymce/plugins/wordcount/plugin");

require("tinymce/plugins/paste/plugin");

require("tinymce/plugins/table/plugin");

require("./plugins/instructure_equation/plugin");

require("./plugins/instructure_image/plugin");

require("./plugins/instructure_equella/plugin");

require("./plugins/instructure_external_tools/plugin");

require("./plugins/instructure_record/plugin");

require("./plugins/instructure_links/plugin");

/*
 * Copyright (C) 2018 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
// prevent tinymce from loading language scripts with explicit
// language_url of 'none'
var originalScriptAdd = _tinymce.default.ScriptLoader.add;

_tinymce.default.ScriptLoader.add = function (url) {
  if (url !== "none") {
    originalScriptAdd.apply(_tinymce.default.ScriptLoader, arguments);
  }
}; // load theme


browser.setFromTinymce(_tinymce.default);
var _default = _tinymce.default;
exports.default = _default;